export default {
    state: {
    },
    mutations: {
    },
    actions: {
        async getRemoteOrdersReportInfo({dispatch}, obj) {
            return await dispatch('apiQuery', {
                method:`/reports/orders_canceled?date_begin=${obj.date_begin}&date_end=${obj.date_end}`
            })
        }
    },
    getters: {
    }
}